import APIDOC from '@/common/serverApi';
import {get, post } from '@/common/request';

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        // 购物车商品列表
        getGoodsList({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.goodsCarList, payload)
                    .then((result) => {
                        if (!payload) {
                            commit('CARINFO', { data: result.data }, { root: true });
                        }
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 删除商品
        deleteGoods({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.deleteGoods, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 下单
        doOrder({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.doOrder, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 增加地址
        doAddAddress({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.addAddress, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 地址列表
        getAddressList({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.addressList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 删除地址
        deleteAddress({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.deleteAddress, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 修改地址
        doEditAddress({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.editAddress, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 邮费计算
        getEmsPrice({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.emsPrice, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 增加发票
        addInvoice({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.addInvoice, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 下单
        doOrderToPay({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.orderToPay, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 新页面打开时调用
        payInfo({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.payInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 分享
        getWxConfig({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.getWxConfig, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 再次下单
        doPayAgain({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.payAgain, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 继续填写订单
        doRepeatOrder({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.repeatToOrder, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 再次购买
        doRepeatToCar({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.repeatToCar, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 设为默认地址
        defaultAddress({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.defaultAddress, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 查看物流
        getLogisticsByOrderId({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getLogisticsByOrderId, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 查看物流
        getLogisticsBylogisticsId({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getLogisticsBylogisticsId, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 查询支付状态
        getPayResult({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.payResult, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 散酒
        getListByIdType({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.listByIdType, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 获取京东链接
        getJdUrl({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getJdUrl, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 成为粉丝
        share2Fan({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                post(APIDOC.GOODS.share2Fan, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        }, // 获取佣金商品列表
        getCommissionGoodsList({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getGoodsList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 获取散酒
        getSanJiu({ commit }) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getSanJiu)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 获取散酒瓶子
        getSanJiuBottle({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getSanJiuBottle, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 获取商品金卡价格
        getGoldenCardPrice({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getGoldenCardPrice, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        // 根据商品ID获取商品信息
        getGoodsInfoList({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getGoodsInfoList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        //更加订单ID查询订单信息
        getOrderInfoId({ commit }, payload) {
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.GOODS.getOrderInfoId, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        //领券
        getCoupons({commit}, payload) {
          commit('STARTREQUEST', null, {root: true});
          return new Promise((resolve, reject) => {
            post(APIDOC.GOODS.getCoupons, payload)
              .then((result) => {
                commit('ENDREQUEST', null, {root: true});
                resolve(result);
              })
              .catch((err) => {
                commit('ENDREQUEST', null, {root: true});
                reject(err);
              });
          });
        },
        //获取优惠券List
        getCouponsList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              get(APIDOC.GOODS.getCouponsList, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          }
          ,
        //根据订单ID获取优惠券信息
        getCouponLists({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              get(APIDOC.GOODS.getCouponLists, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          },
          //根据商品ID查询关联的可用的优惠券
          getListByGoodsId({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              get(APIDOC.GOODS.getListByGoodsId, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          },
          //生成带优惠券的商品链接
          createGoodsUrlWithCoupons({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              post(APIDOC.GOODS.createGoodsUrlWithCoupons, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          },
          //根据商品ID获取商品二维码信息
          getGoodsQRCode({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              get(APIDOC.GOODS.getGoodsQRCode, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          },
          //带券链接领取结果 被关掉调用接口
          closeGetCouponResult({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              post(APIDOC.GOODS.closeGetCouponResult, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          },
          //根据电话或近三天的微信名名字进行匹配
          matching({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              get(APIDOC.GOODS.matching, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          },
          //根据近三天的微信名进行电话地址的匹配
          confirmMatching({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
              post(APIDOC.GOODS.confirmMatching, payload)
                .then((result) => {
                  commit('ENDREQUEST', null, {root: true});
                  resolve(result);
                })
                .catch((err) => {
                  commit('ENDREQUEST', null, {root: true});
                  reject(err);
                });
            });
          }
        // todo
    }
};


// WEBPACK FOOTER //
// ./src/store/goods.js